<template>
  <div class="mx-auto max-w-[320px]">
    <div class="space-y-4 text-center">
      <PrimeFloatLabel variant="on">
        <PrimeInputText
          v-model="profile.email"
          type="email"
          input-id="currentEmail"
          autocomplete="current-email"
          disabled
        />
        <label for="currentEmail" style="background: transparent">
          {{ $t('components.settings.email.currentEmail') }}
        </label>
      </PrimeFloatLabel>

      <PrimeButton
        v-if="!showUpdateEmail"
        type="button"
        :label="$t('components.settings.email.updateYourEmail')"
        @click="() => (showUpdateEmail = true)"
      />
      <form
        v-if="showUpdateEmail"
        class="space-y-4"
        @submit.prevent="handleUpdateEmail"
      >
        <PrimeFloatLabel variant="on">
          <PrimeInputText
            v-model="newEmail"
            type="email"
            input-id="newEmail"
            autocomplete="new-email"
            required
          />
          <label for="newEmail">{{ $t('components.settings.email.newEmail') }}</label>
        </PrimeFloatLabel>

        <div class="flex items-center justify-between">
          <PrimeButton
            type="button"
            :label="$t('components.settings.email.cancel')"
            outlined
            @click="() => (showUpdateEmail = false)"
          />
          <PrimeButton
            type="submit"
            :loading="pending"
            :label="pending ? $t('components.settings.email.updatingEmail') : $t('components.settings.email.updateEmail')"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';

export default defineNuxtComponent({
  data() {
    return {
      newEmail: null,
      showUpdateEmail: false,
      pending: false,
    };
  },
  computed: {
    ...mapState(useAuthStore, ['profile']),
  },
  methods: {
    async handleUpdateEmail() {
      this.pending = true;
      const { error } = await useApi('/api/auth/request-update-email', {
        method: 'POST',
        body: { newEmail: this.newEmail },
      });
      if (error) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('components.settings.email.updateFailed'),
          detail: this.$t('errors.' + error),
          life: 4000,
        });
      } else {
        this.$toast.add({
          severity: 'success',  
          summary: this.$t('components.settings.email.success'),
          detail: this.$t('components.settings.email.successEmailSent'),
          life: 4000,
        });
      }

      this.pending = false;
    },
  },
});
</script>

<style  scoped></style>
